var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBelliconOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41543 48.1692C4.65716 48.1669 3.94043 47.8281 3.45415 47.2473C2.96786 46.6666 2.76273 45.8991 2.89642 45.1524L3.73304 40.4485C4.27003 37.3971 4.09488 34.2629 3.2191 31.2917L1.48137 25.4101C-0.108856 20.0401 1.28778 14.2325 5.1435 10.1716C8.99927 6.11072 14.7286 4.41677 20.1726 5.72581C25.6165 7.03484 29.9489 11.1487 31.5371 16.5187L33.2772 22.4003V22.398C34.1599 25.3687 35.7178 28.0928 37.8289 30.3606L41.09 33.8522C41.6984 34.5022 41.9243 35.4194 41.6915 36.2791C41.4564 37.1364 40.795 37.814 39.9423 38.0652L6.15122 48.0627C5.91153 48.1319 5.66493 48.1687 5.41602 48.1687L5.41543 48.1692ZM16.5033 7.13414C12.1428 7.13875 8.03798 9.19684 5.429 12.6931C2.82008 16.187 2.01343 20.7064 3.24877 24.8872L4.9888 30.7688H4.9865C5.94525 34.0138 6.13653 37.4387 5.54654 40.771L4.70992 45.4749C4.66382 45.7215 4.7514 45.9751 4.94038 46.141C5.12476 46.3115 5.38749 46.3691 5.6272 46.2931L39.4206 36.2979C39.6603 36.2265 39.8447 36.0352 39.9115 35.7955C39.9761 35.5535 39.9138 35.2954 39.7433 35.1133L36.4822 31.6217V31.6194C34.1752 29.1442 32.472 26.1665 31.5087 22.9216L29.7686 17.04V17.0423C28.9182 14.1822 27.169 11.6724 24.7767 9.88858C22.3867 8.10247 19.4851 7.13676 16.5031 7.13446L16.5033 7.13414Z",
    fill: "url(#paint0_linear_385_529)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2622 8.64901C9.02712 8.64901 8.79896 8.55913 8.62842 8.3955C7.43462 7.26157 6.93448 5.57689 7.31933 3.9751C7.70421 2.37337 8.91416 1.09885 10.4929 0.630977C12.0716 0.163107 13.7817 0.575665 14.9755 1.70956C16.1693 2.84348 16.6695 4.52816 16.2823 6.12996C16.1647 6.62546 15.6669 6.9297 15.1714 6.80981C14.6759 6.68997 14.3717 6.19214 14.4915 5.69896C14.8165 4.34839 14.0882 2.96791 12.793 2.47007C11.4978 1.97225 10.0343 2.51155 9.37053 3.73072C8.77362 4.83007 8.98795 6.19444 9.89369 7.05637C10.1679 7.31681 10.2578 7.71552 10.1172 8.0658C9.97896 8.41842 9.64018 8.64889 9.26222 8.64889L9.2622 8.64901Z",
    fill: "url(#paint1_linear_385_529)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6156 48.6608C19.9837 48.7529 17.6029 47.1005 16.771 44.5999C16.635 44.1136 16.9139 43.6089 17.3979 43.466C17.8818 43.3208 18.3912 43.595 18.541 44.079C19.3891 46.2962 21.8643 47.4209 24.093 46.6004C25.2592 46.2731 26.2617 45.5264 26.9139 44.5077C27.5016 43.6066 27.6722 42.498 27.3795 41.4632C27.2366 40.9746 27.5131 40.4629 28.0017 40.3177C28.4903 40.1725 29.002 40.4514 29.1472 40.94C29.592 42.4796 29.35 44.1343 28.4788 45.4802C27.5892 46.8838 26.2156 47.9117 24.6161 48.368C23.9662 48.5616 23.2932 48.6607 22.6157 48.6607L22.6156 48.6608Z",
    fill: "url(#paint2_linear_385_529)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87853 39.7488C4.4199 39.7488 4.0304 39.4123 3.96586 38.9583C3.90132 38.5043 4.17789 38.0733 4.6181 37.9419L35.7247 28.7391C35.9597 28.6677 36.2133 28.693 36.4299 28.8083C36.6488 28.9258 36.8102 29.124 36.8793 29.3591C36.9485 29.5965 36.9208 29.85 36.801 30.0666C36.6834 30.2809 36.4829 30.44 36.2455 30.5068L5.13895 39.7096C5.05368 39.735 4.9661 39.7488 4.87852 39.7488L4.87853 39.7488Z",
    fill: "url(#paint3_linear_385_529)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7312 40.6306C43.3993 40.6306 43.0928 40.4509 42.9314 40.1628C42.7678 39.8724 42.7724 39.5174 42.943 39.234C44.7498 36.2195 43.8833 32.3174 40.9701 30.3516C40.7673 30.2156 40.6244 30.0036 40.5783 29.7639C40.5299 29.5219 40.5806 29.273 40.7189 29.0701C40.8549 28.8673 41.0692 28.7267 41.3089 28.6807C41.5509 28.6346 41.7998 28.6853 42.0026 28.8235C45.727 31.3379 46.8356 36.3278 44.5239 40.1834C44.3557 40.46 44.0561 40.6305 43.7311 40.6305L43.7312 40.6306Z",
    fill: "url(#paint4_linear_385_529)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_385_529",
    x1: 0.83606,
    y1: 26.7301,
    x2: 41.7814,
    y2: 26.7301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.79233e-9,
    stopColor: "#FC8162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF406F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_385_529",
    x1: 7.19177,
    y1: 4.54521,
    x2: 16.4111,
    y2: 4.54521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.79233e-9,
    stopColor: "#FC8162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF406F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_385_529",
    x1: 16.7366,
    y1: 44.4719,
    x2: 29.3652,
    y2: 44.4719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.79233e-9,
    stopColor: "#FC8162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF406F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_385_529",
    x1: 3.95654,
    y1: 34.224,
    x2: 36.9166,
    y2: 34.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.79233e-9,
    stopColor: "#FC8162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF406F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_385_529",
    x1: 40.5604,
    y1: 34.6474,
    x2: 45.7288,
    y2: 34.6474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.79233e-9,
    stopColor: "#FC8162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF406F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelliconOutlined);
export default __webpack_public_path__ + "static/media/BelliconOutlined.a46ace37c8a343badd09905bf3bad085.svg";
export { ForwardRef as ReactComponent };